// Simple function to check if user is new
export const isNewUser = (savedDrafts: any[]): boolean => {
  const isNew = savedDrafts.length === 0;
  console.log('Is new user:', isNew);
  return isNew;
}; 